import { Component, OnInit } from '@angular/core';
import * as Highcharts from 'highcharts/highmaps'; 
import { HighchartsChartModule } from 'highcharts-angular';
import { NgIf } from '@angular/common';
import CambodiaMapData from '../../assets/maps/cambodia_map.json';


@Component({
  selector: 'app-cambodia-map',
  standalone: true,
  imports: [HighchartsChartModule, NgIf],
  templateUrl: './cambodia-map.component.html',
  styleUrl: './cambodia-map.component.css'
})
export class CambodiaMapComponent {

  Highcharts: typeof Highcharts = Highcharts;
  chartOptions: Highcharts.Options = {};
  loading: boolean = true;

  async ngOnInit() {
    // Fetch Cambodia map from Highcharts CDN
    // const topology = await fetch(
    //   'https://code.highcharts.com/mapdata/countries/kh/kh-all.topo.json'
    // ).then(res => res.json());

    const data: [string, number][] = [
      ['kh-kk', 10], ['kh-pp', 11], ['kh-ka', 12], ['kh-om', 13],
      ['kh-ba', 14], ['kh-po', 15], ['kh-si', 16], ['kh-oc', 17],
      ['kh-pl', 18], ['kh-km', 19], ['kh-kg', 20], ['kh-kn', 21],
      ['kh-ks', 22], ['kh-kt', 23], ['kh-py', 24], ['kh-ph', 25],
      ['kh-st', 26], ['kh-kh', 27], ['kh-mk', 28], ['kh-ro', 29],
      ['kh-kp', 30], ['kh-ke', 31], ['kh-sr', 32], ['kh-ta', 33]
    ];

    this.chartOptions = {
      title: { text: 'ផែនទីប្រទេសកម្ពុជា' },
      mapNavigation: { enabled: true, buttonOptions: { verticalAlign: 'bottom' } },
      colorAxis: { min: 0 },
      tooltip: { pointFormat: '{point.name}: {point.value}' },
      series: [{
        type: 'map',
        mapData: CambodiaMapData as any,
        data: data,
        name: 'Random Data',
        states: { hover: { color: '#BADA55' } },
        dataLabels: { enabled: true, format: '{point.name}' }
      }]
    };

    this.loading = false;
  }
}
